export default "__VITE_ASSET__38a6dde7__"